import { sxTable } from './sxProps';
import './styles.css'
import { Table, TableBody, TableContainer, TableHead, TableCell, TableRow, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TabelaComprovantesProps } from '../../../interfaces/props/Financeiro/ComprovanteRecebidos/TabelaComprovantesProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

function TabelaComprovantes(props: TabelaComprovantesProps) {

    const accessibility = useAccessibility();

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
      ...{
        fontFamily: 'Unimed-Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        width: '25%'
      },
      ...accessibility.textStyleAccessibility
    }));
      
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
          backgroundColor: '#F9F9F9'
      },
    }));

    return (
        <div>
          <TableContainer sx={sxTable} component={Paper} style={accessibility.contrastBorderAccessibility}>
            <Table stickyHeader size="small" aria-label="a dense table">
                <TableHead>
                <TableRow>
                    <StyledTableCell><b>Ano de referência</b></StyledTableCell>
                    <StyledTableCell align="left"><b>Demonstrativo</b></StyledTableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {props.data.map((row, i) => (
                    <StyledTableRow
                        key={i}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <StyledTableCell component="th" scope="row">
                            {row.exercicio}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                            <button 
                                className='demonstrativo-button' 
                                onClick={()=> props.onVisualizarClicked(row.pdf)}
                                style={accessibility.textStyleAccessibility}
                                aria-label={`visualizar comprovante do ano ${row.exercicio}`}
                            >
                                visualizar
                            </button>
                        </StyledTableCell>
                    </StyledTableRow>
                ))}
                </TableBody>
            </Table>
            </TableContainer>
        </div>
    )
}

export default TabelaComprovantes;